import { useQuery } from "@tanstack/react-query";
import { api } from "jiffy-api";

const CACHED_DELIVERY_DATE_QUERY_KEY = ["cachedDeliveryDate"] as const;

export async function fetchCachedDeliveryDateQuery() {
  try {
    const response = await api.product.fetchCachedDeliveryDate();

    if (response.success && response.cached_delivery_date) {
      return response.cached_delivery_date;
    }

    return null;
  } catch {
    // Handle 503 and other errors gracefully - treat as "cached delivery not available"
    // This allows fallback to estimated delivery API
    return null;
  }
}

export function useCachedDeliveryDate() {
  return useQuery({
    enabled: false, // Never fetch on mount - we use initial value from config
    queryKey: CACHED_DELIVERY_DATE_QUERY_KEY,
    queryFn: fetchCachedDeliveryDateQuery,
    // Don't use initialData or placeholderData - let React Query use cache directly
    // Initial value is handled in useFormattedDeliveryDate
    staleTime: 0, // Ensure data is always considered stale
    notifyOnChangeProps: ["data", "isFetched", "isFetching", "isLoading", "isError"], // Ensure re-renders on cache updates
    retry: false // Don't retry on error - treat as "not available" and fallback
  });
}

export { CACHED_DELIVERY_DATE_QUERY_KEY };
